export function heroBgSlider() {
    let initializedClassName = "initialized";

    $(".hero-bg-slider").each(function () {
        let slider = $(this);

        if (!slider.hasClass(initializedClassName)) {
            let items = slider.find(".picture");

            if (items.length > 1) {

                slider
                    .addClass(initializedClassName)
                    .slick({
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        mobileFirst: true,
                        fade: true,
                        dots: true,
                        appendDots: $(".hero-gallery-dots"),
                        arrows: false,
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: true,
                                    appendArrows: $(".hero-gallery-buttons"),
                                    dots: true,
                                    appendDots: $(".hero-gallery-dots"),
                                }
                            }
                        ]
                    });
            }
        }
    });
}








// WEBPACK FOOTER //
// ./assets/js/modules/heroBgSlider.js